export default "__VITE_ASSET__58a70379__"